import styled from "styled-components";


export const LobbyWrapperDefaultBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  line-height: normal;
  padding-left: 4rem;
  padding-right: 4rem;
  min-height: 100vh;
  padding-bottom: 100px;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 1.5rem;
    padding-left: 0;
    padding-right: 0;
  }
  
  &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0;
        top: 0;
        background-image: radial-gradient(50% 80% at top, rgba(0,0,0,0.5), transparent);
        background-repeat: no-repeat;
        background-position: center top;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: none;
        opacity: 0;
    }

  }
`;

export const LobbyWrapperWithoutBackgroundDefaultBox = styled(LobbyWrapperDefaultBox)`
  &:before {
    background-image: none;
  }
`